var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import keycode from 'keycode';
import classnames from 'classnames';

var PADDING_LEFT = 16;
var LIST_ITEM_HEIGHT = 48;

// list length
var MAX_LIST_LENGTH = 5;

var defaultFindIndex = function defaultFindIndex(options, filterValue, startIndex) {
  filterValue = filterValue.toLowerCase();
  var findIndex = options.findIndex(function (_ref, i) {
    var label = _ref.label;
    return i > startIndex && label.toLowerCase().startsWith(filterValue);
  });
  if (findIndex === -1) {
    findIndex = options.findIndex(function (_ref2) {
      var label = _ref2.label;
      return label.toLowerCase().startsWith(filterValue);
    });
  }
  return findIndex;
};

var Select = function (_React$Component) {
  _inherits(Select, _React$Component);

  function Select() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, Select);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = Select.__proto__ || Object.getPrototypeOf(Select)).call.apply(_ref3, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.onKeyDown = function (event) {
      if (event.which === keycode('enter') || event.which === keycode('space')) {
        event.preventDefault();
        _this.open();
        return;
      }
      var _this$props = _this.props,
          options = _this$props.options,
          value = _this$props.value;

      var index = options.findIndex(function (option) {
        return option.value === value;
      });
      if (event.which === keycode('up') || event.which === keycode('left')) {
        event.preventDefault();
        if (index > 0) {
          var prev = options[index - 1];
          return _this.props.onChange({
            target: _extends({
              name: _this.props.name
            }, prev)
          });
        }
      }
      if (event.which === keycode('down') || event.which === keycode('right')) {
        event.preventDefault();
        if (index < options.length - 1) {
          var next = options[index + 1];
          return _this.props.onChange({
            target: _extends({
              name: _this.props.name
            }, next)
          });
        }
      }

      if (event.key) {
        var findIndex = _this.props.findIndex(options, event.key, index);
        if (findIndex !== -1) {
          event.preventDefault();
          var _next = options[findIndex];
          return _this.props.onChange({
            target: _extends({
              name: _this.props.name
            }, _next)
          });
        }
      }
    }, _this.open = function () {
      if (_this.props.disabled) {
        return;
      }
      _this.setState({
        open: true
      });
      document.addEventListener('click', _this.close);
    }, _this.close = function () {
      _this.setState({
        open: false
      });
      document.removeEventListener('click', _this.close);
    }, _this.findTableTag = function (node) {
      while (node.parentNode) {
        node = node.parentNode;
        if (node.tagName === 'TABLE') {
          return true;
        }
      }
      return false;
    }, _this.onChange = function (item) {
      _this.props.onChange({
        target: _extends({
          name: _this.props.name
        }, item)
      });
    }, _this.onEnter = function (item) {
      _this.props.onChange({
        target: _extends({
          name: _this.props.name
        }, item)
      });
      _this.onEscape();
    }, _this.onEscape = function () {
      _this.close();
      _this.refInput.focus();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Select, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var isInsideTable = this.findTableTag(this.refWrapper);
      this.setState({
        isInsideTable: isInsideTable
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.state.open && nextState.open) {
        return false;
      }
      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var selectedIndex = this.props.options.findIndex(function (option) {
        return option.value === _this2.props.value;
      });
      var empty = selectedIndex === -1;
      var text = empty ? this.props.placeholder : this.props.options[selectedIndex].label;

      return React.createElement(
        'div',
        {
          className: classnames('mdc-Select', {
            'mdc-Select--dense': this.props.dense,
            'is-insideTable': this.state.isInsideTable
          }),
          ref: function ref(c) {
            _this2.refWrapper = c;
          }
        },
        React.createElement('input', {
          className: 'mdc-Select-input',
          name: this.props.name,
          value: this.props.value,
          disabled: this.props.disabled,
          onKeyDown: this.onKeyDown,
          ref: function ref(elem) {
            _this2.refInput = elem;
          },
          readOnly: true
        }),
        this.props.label && React.createElement(
          'span',
          { className: 'mdc-Select-label' },
          this.props.label
        ),
        React.createElement(
          'div',
          {
            className: 'mdc-Select-body',
            onClick: this.open
          },
          React.createElement(
            'span',
            { className: empty ? 'mdc-Select-placeholder' : '' },
            text
          ),
          React.createElement('span', { className: 'mdc-Select-caret' })
        ),
        this.state.open && React.createElement(List, {
          options: this.props.options,
          selectedIndex: selectedIndex,
          onClick: this.onChange,
          onEnter: this.onEnter,
          refWrapper: this.refWrapper,
          isInsideTable: this.state.isInsideTable,
          onEscape: this.onEscape,
          findIndex: this.props.findIndex,
          dense: this.props.dense
        }),
        React.createElement(
          'div',
          { className: classnames('mdc-Select-helper', {
              'mdc-Select-helper--error': this.props.error,
              'mdc-Select-helper--dense': this.props.dense
            }) },
          this.props.error || this.props.helper
        )
      );
    }
  }]);

  return Select;
}(React.Component);

Select.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  findIndex: PropTypes.func,
  dense: PropTypes.bool
};
Select.defaultProps = {
  options: [{ value: 'one', label: 'one' }, { value: 'two', label: 'two' }, { value: 'three', label: 'three' }],
  placeholder: 'Placeholder',
  value: '',
  findIndex: defaultFindIndex,
  dense: false
};
export default Select;


export var List = function (_React$Component2) {
  _inherits(List, _React$Component2);

  function List() {
    var _ref4;

    var _temp2, _this3, _ret2;

    _classCallCheck(this, List);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref4 = List.__proto__ || Object.getPrototypeOf(List)).call.apply(_ref4, [this].concat(args))), _this3), _this3.state = {
      left: _this3.props.refWrapper.getBoundingClientRect().left,
      top: _this3.props.refWrapper.getBoundingClientRect().top,
      width: _this3.props.refWrapper.getBoundingClientRect().width
    }, _this3.resize = function () {
      var _this3$props$refWrapp = _this3.props.refWrapper.getBoundingClientRect(),
          left = _this3$props$refWrapp.left,
          top = _this3$props$refWrapp.top,
          width = _this3$props$refWrapp.width;

      _this3.setState({
        left: left,
        top: top,
        width: width
      });
    }, _this3.onClick = function (event) {
      var index = parseInt(event.currentTarget.getAttribute('data-id'));
      _this3.props.onClick(_this3.props.options[index]);
    }, _this3.onBlur = function (event) {
      // close list when focus is outside of list
      if (event.relatedTarget && !event.relatedTarget.classList.contains('mdc-Select-listItem')) {
        _this3.props.onEscape();
      }
    }, _this3.onKeyDown = function (event) {
      var index = parseInt(event.currentTarget.getAttribute('data-id'));
      if (event.which === keycode('enter')) {
        return _this3.props.onEnter(_this3.props.options[index]);
      }
      if (event.which === keycode('escape')) {
        return _this3.props.onEscape();
      }
      if (event.which === keycode('down')) {
        event.preventDefault();
        if (event.target.nextSibling) {
          return event.target.nextSibling.focus();
        }
      }
      if (event.which === keycode('up')) {
        event.preventDefault();
        if (event.target.previousSibling) {
          return event.target.previousSibling.focus();
        }
      }

      var findIndex = _this3.props.findIndex(_this3.props.options, event.key, index);
      if (findIndex !== -1) {
        event.preventDefault();
        _this3['li' + findIndex].focus();
      }
    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
  }

  _createClass(List, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      LIST_ITEM_HEIGHT = this.props.dense ? 36 : LIST_ITEM_HEIGHT;
      var index = this.props.selectedIndex;

      // create boolean helper variables
      var scrollable = this.props.options.length > MAX_LIST_LENGTH;
      var indexWithinFirstTwoItems = index < 2;

      if (scrollable && !indexWithinFirstTwoItems) {
        var scrollTop = LIST_ITEM_HEIGHT * (index - 2);
        this.ref.scrollTop = scrollTop;
      }

      var focus = index >= 0 ? index : 0;
      this['li' + focus].focus();

      window.addEventListener('resize', this.resize);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resize);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      LIST_ITEM_HEIGHT = this.props.dense ? 36 : LIST_ITEM_HEIGHT;
      // CSS space
      var PADDING_TOP = -20;
      if (this.props.isInsideTable) {
        // when select component is inside a table cell we have to remove
        // border bottom, padding top and padding bottom.
        // this changes the location of the text.
        // that leads to the list menu / overlay no being directly on top of the text.
        // we therefore have to modify the padding top to fix the overlay position.
        PADDING_TOP = 24;
      }

      if (this.props.dense) {
        PADDING_TOP = -13;
      }

      var _props = this.props,
          options = _props.options,
          selectedIndex = _props.selectedIndex;

      // handle list absolute position top

      var paddingTop = PADDING_TOP;

      var top = void 0;
      if (selectedIndex === -1) {
        // set position to first element, i.e. selectedIndex = 0
        top = -1 * paddingTop;
      } else {
        top = -1 * (paddingTop + LIST_ITEM_HEIGHT * selectedIndex);
      }

      // handle scrollable lists with more than 5 list items
      if (options.length > MAX_LIST_LENGTH) {
        if (selectedIndex >= 2 && selectedIndex <= options.length - 3) {
          // handle "center" items => always set to third position
          top = -1 * (paddingTop + LIST_ITEM_HEIGHT * 2);
        } else if (selectedIndex === options.length - 2) {
          // handle second last item
          top = -1 * (paddingTop + LIST_ITEM_HEIGHT * 3);
        } else if (selectedIndex === options.length - 1) {
          // handle last item
          top = -1 * (paddingTop + LIST_ITEM_HEIGHT * 4);
        }
      }

      var width = this.state.width + 2 * PADDING_LEFT;
      var left = this.props.isInsideTable ? -17 : -16;
      var padding = 16;

      // check if select overlay is wider than window which would cause horizontal overflow
      // if so decrease padding left and right from 16px to 8px
      // adjust absolute position left and inner link padding accordingly
      if (width > document.body.clientWidth) {
        width = this.state.width + PADDING_LEFT;
        left = -8;
        padding = 8;
      }

      // select component is position fixed
      // add top and left from select component
      top = top + this.state.top;
      left = left + this.state.left;

      // Checks that the attempted overlay position will fit within the viewport.
      // If it will not fit, tries to adjust the position 'top' so the panel can open fully on-screen.
      // If the select panel is very bottom, tries to adjust the position 'top' so the panel can open fully on-screen.
      // If it still won't fit, sets the offset back to 0 to allow the fallback position to take over.
      var innerHeight = window.innerHeight;
      var listHeight = LIST_ITEM_HEIGHT * Math.min(MAX_LIST_LENGTH, options.length);
      if (this.props.isInsideTable) {
        listHeight += PADDING_TOP;
      } else {
        listHeight -= PADDING_TOP;
      }
      if (top < 0) {
        top = 0;
      } else if (top + listHeight > innerHeight) {
        top = Math.max(0, innerHeight - listHeight);
      }
      var style = { top: top, width: width, left: left };

      return React.createElement(
        'ul',
        {
          ref: function ref(c) {
            _this4.ref = c;
          },
          className: 'mdc-Select-list',
          style: style
        },
        options.map(function (item, i) {
          return React.createElement(
            'li',
            { key: i,
              tabIndex: '0',
              className: 'mdc-Select-listItem',
              'data-id': i,
              onClick: _this4.onClick,
              style: { padding: '0 ' + padding + 'px' },
              onKeyDown: _this4.onKeyDown,
              onBlur: _this4.onBlur,
              ref: function ref(elem) {
                _this4['li' + i] = elem;
              }
            },
            item.label
          );
        })
      );
    }
  }]);

  return List;
}(React.Component);
List.propTypes = {
  options: PropTypes.array.isRequired,
  isInsideTable: PropTypes.bool,
  selectedIndex: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  refWrapper: PropTypes.object.isRequired,
  findIndex: PropTypes.func
};


//////////////////
// WEBPACK FOOTER
// ../es/js/select/index.js
// module id = 120
// module chunks = 0